
            const data = {"name":"addMark","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M12 5v14M5 12h14\" _stroke=\"#F1B9B4\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>","originalColors":[{"type":"stroke","color":"#F1B9B4"}],"stopColors":[]}}
        
                    module.exports = data
                    